import { create } from 'zustand';
import api from '../lib/api';
import type { TodayResponse } from '../types';

interface TodayState {
  data: TodayResponse | null;
  isLoading: boolean;
  error: string | null;
  fetch: () => Promise<void>;
}

export const useTodayStore = create<TodayState>((set) => ({
  data: null,
  isLoading: false,
  error: null,
  fetch: async () => {
    set({ isLoading: true, error: null });
    try {
      const res = await api.get('/api/dashboard/today');
      set({ data: res.data as TodayResponse, isLoading: false });
    } catch (error: any) {
      set({ isLoading: false, error: error.response?.data?.message || 'Failed to load your day' });
    }
  },
}));
